var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-h5 q-pb-md q-my-md text-left fields-tab-header"},[_vm._v(" Settings for "+_vm._s(_vm.user_instance.address_string)+" ")]),_c('basic-info',{staticClass:"bg-grey-1"}),_c('user-permissions',{staticClass:"bg-grey-1"}),_c('additional-info',{staticClass:"bg-grey-1"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }